import React from 'react';
import { Backdrop, CircularProgress } from '@mui/material';

const Loader = ({ open }) => (
  <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open}>
    <CircularProgress color="inherit" />
  </Backdrop>
);

export default Loader;